import React from 'react';

import {
  Stack, Typography, useTheme,
} from '@mui/material';

import Chip from '../../../../../components/Chip';
import ContentCard from '../../../../../components/ContentCard';
import ProfileIcon from '../../../../../components/ProfileIcon';
import StudentStateChip from '../../../../../components/StudentStateChip';
import UserDisabledStateChip from '../../../../../components/UserDisabledStateChip';
import { Student } from '../../../../../services/students/types';
import { AttendanceType } from '../../../../../types/common';

interface ProfileCardProps {
  student?: Student,
}

const ProfileCard = ({ student }: ProfileCardProps) => {
  const theme = useTheme();

  return (
    <ContentCard>
      <Stack direction="row" spacing={2} alignItems="center">
        <ProfileIcon
          firstName={student?.firstName}
          lastName={student?.lastName}
          color={student?.profileIcon?.color}
          imageUrl={student?.profileIcon?.image}
          size={96}
        />
        <Stack direction="column" spacing={1}>
          <Typography variant="h4" color={theme.palette.darkPrimary.main}>{student?.name}</Typography>
          <Stack direction="row" spacing={1}>
            {student?.state &&
            <StudentStateChip state={student.state} />}
            {student?.disabled !== undefined &&
            <UserDisabledStateChip disabled={student.disabled} />}
            {student?.attendanceType === AttendanceType.Online &&
            <Chip label="Online" color="lightBlue" />}
          </Stack>
        </Stack>
      </Stack>
    </ContentCard>
  );
};

export default ProfileCard;
